package org.hs_soft.runmynesto.domain.usecase.product.tab_selection

import org.hs_soft.runmynesto.domain.model.home.product.tabs.tab_selection.update_product_sets.ProductSetsModel
import org.hs_soft.runmynesto.domain.repository.network_datasource.product.tab_selection.UpdateProductSetRepository

class UpdateProductSetUseCase(
    private val repository: UpdateProductSetRepository
) {
    suspend operator fun invoke(
        id:String,
        title:String,
        value:dynamic,
    ):ProductSetsModel {

        return repository.updateProductSet(
            id = id,
            title = title,
            value = value
        )
    }
}